import styled from 'styled-components';
import { halfStep } from 'tokens';

export const CHATS_HEADER_HEIGHT = 36;
export const Base = styled.div`
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	min-height: 0;
	overflow-y: auto;
	padding-bottom: 12px;
`;

export const Header = styled.div`
	// layout
	height: ${CHATS_HEADER_HEIGHT}px;
	min-height: ${CHATS_HEADER_HEIGHT}px;
	padding-left: 14px;
	padding-right: 4px;
	display: flex;
	align-items: center;
	flex-shrink: 0;

	// style
	background: transparent;
	justify-content: space-between;
`;

interface LabelProps {
	empty?: boolean;
}
export const Label = styled.div<LabelProps>`
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme, empty }) => (empty ? theme.gray[400] : theme.gray[1000])};
	user-select: none;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const ButtonGroup = styled.div`
	display: flex;
	gap: 0px;
	align-items: center;
`;

export const EmptyStateNoStyles = styled.div`
	margin-top: 16px;
	margin-left: 16px;
	margin-right: 16px;
`;

export const Body = styled.div`
	font-size: 13px;
	line-height: 20px;
	font-weight: 400;
	color: ${({ theme }) => theme.gray[1000]};
	user-select: none;
`;

export const PropertyRow = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const PropertyLabel = styled.div`
	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	user-select: none;
	flex: 1;
	min-width: 0;
	display: flex;
	align-items: center;
	height: 24px;
	overflow: hidden;
	background: ${({ theme }) => theme.gray[100]};
	border: 1px solid transparent;
	margin-top: 8px;
	border-radius: ${halfStep}px;
	padding-left: 6px;
`;

export const PropertyColorWrapper = styled.div`
	padding-right: 6px;
	width: 100px;
	padding-right: 14px;
`;

export const PropertySpacer = styled.div`
	width: 0px;
`;

export const Button = styled.button`
	background: transparent;
	border: none;
	padding-top: 3px;
	padding-left: 3px;
	border-radius: 6px;
	width: 24px;
	height: 24px;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

// nested buttons are not allowed so we have a separate style for the dropdown trigger
export const DropdownTrigger = styled.div`
	background: transparent;
	border: none;
	border-radius: 6px;
	padding-left: 1px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const StyleEntries = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding-top: 12px;
`;

export const StyleEntry = styled.div`
	// layout
	height: 32px;
	display: flex;
	align-items: center;
	padding-left: 8px;
	margin-right: 6px;
	gap: 8px;
	// style
	color: ${({ theme }) => theme.gray[1000]};
	border-radius: 6px;
	background-color: transparent;
	font-size: 11px;
	font-weight: 500;
	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
	}
`;

export const StyleEntryText = styled.div`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	margin-top: -1px;

	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	user-select: none;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
